const reducer = (state: WtrState) => ({
  ...state,
  slots: [],
  error: null,
});

export default reducer;
